module.exports = __webpack_public_path__ + "static/media/bigbuy.4290c9e8.svg";